import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { fetchAppInfo } from '@/api/system/app';
import { dailyCostList } from '@/common/demand';

var finalProduct = {
  app_id: '',
  app_name: '',
  package_name: ''
};

export default {
  props: {
    index: {
      type: Number,
      required: true
    },

    product: {
      type: Object,
      required: true
    },

    demand: {
      type: Object,
      required: true
    },

    updateProduct: {
      type: Function,
      default: function _default() {}
    },

    validate: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      formConfig: {
        labelWidth: '150px'
      },

      finalProduct: _extends({}, finalProduct)
    };
  },


  computed: {
    formItemList: function formItemList() {
      return {
        app_url: {
          label: '产品链接',
          prop: 'app_url',
          rules: [{
            required: true,
            message: '请输入产品链接',
            trigger: 'blur'
          }],
          params: {
            type: 'text',
            clearable: true,
            placeholder: '请输入产品链接',
            disabled: this.demand.material_source === 3 && !!this.finalProduct.app_url
          }
        },
        app_name: {
          label: '产品名称',
          prop: 'app_name',
          rules: [{
            required: true,
            message: '请输入产品名称',
            trigger: 'blur'
          }],
          params: {
            type: 'text',
            clearable: true,
            placeholder: '请输入产品名称',
            disabled: !!this.finalProduct.app_name || this.demand.material_source === 3 && !!this.finalProduct.app_name
          }
        },
        package_name: {
          label: '包名(必填)',
          prop: 'package_name',
          params: {
            type: 'text',
            clearable: true,
            placeholder: '请输入包名',
            disabled: !!this.finalProduct.package_name || this.demand.material_source === 3 && !!this.finalProduct.package_name
          },
          rules: [{
            required: true,
            message: '请输入包名',
            trigger: 'blur'
          }]
        },
        offer_uuid: {
          label: 'UUID(非必填)',
          prop: 'offer_uuid',
          rules: [],
          params: {
            type: 'text',
            clearable: true,
            placeholder: '请输入UUID',
            disabled: this.demand.material_source === 3
          }
        },
        mtg_daily_cost: {
          label: 'Mtg渠道日均消耗',
          prop: 'mtg_daily_cost',
          params: {
            clearable: true,
            options: _.cloneDeep(dailyCostList),
            placeholder: '请选择Mtg渠道日均消耗'
          }
        }
      };
    }
  },

  watch: {
    'product.app_url': function productApp_url(val) {
      if (val) this.debounceGetAppInfo({ app_url: val });else this.resetFinalProduct();
    },
    'product.offer_uuid': function productOffer_uuid(val) {
      // eslint-disable-next-line vue/no-mutating-props
      if (!val) this.product.mtg_daily_cost = '';
    },


    // 如果 finalProduct 存在的值，则将对应的控件修改为只读状态
    finalProduct: {
      handler: function handler(newVal) {
        this.updateProduct(this.index, _extends({}, this.product, this.finalProduct));
      },

      deep: true
    }
  },

  created: function created() {
    // 在 mounted 中注册回出错
    this.debounceGetAppInfo = _.debounce(this.getAppInfo, 100);
  },
  mounted: function mounted() {
    var _this = this;

    this.form = this.$refs.form;
    this.$root.$once('demand:get-app-info', function () {
      _this.product.app_url && _this.getAppInfo({ app_url: _this.product.app_url });
    });
  },


  methods: {
    /**
     * @param {{app_url: string, app_id: string}} params，二者选一即可
     */
    getAppInfo: function getAppInfo(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, info;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetchAppInfo(params);

              case 3:
                res = _context.sent;
                info = _.get(res, 'data.data.info');


                if (info) {
                  _this2.finalProduct = {
                    app_id: info.id || '',
                    app_name: info.name || '',
                    package_name: info.package_name || ''
                  };
                } else if (_this2.demand.material_source === 3) {
                  // 使用ss提供默认值，不重置
                } else {
                  _this2.resetFinalProduct();
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                _this2.resetFinalProduct();

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 8]]);
      }))();
    },
    resetFinalProduct: function resetFinalProduct() {
      this.finalProduct = _extends({}, finalProduct);
    }
  }
};